export default "__VITE_ASSET__MmkxuZ7B__"